<template>
  <section
    id="plan"
    class="co-bg-striped px-5 py-20"
  >
    <div class="co-container-md">
      <h2 class="co-heading-2-caption mb-6 text-center">
        学習プランカスタマイズの<br class="sm:hidden">事例
      </h2>
      <div class="mb-12 text-center text-co-gray-600">
        ご要望に合わせたカスタマイズの事例をご紹介
      </div>
      <!-- ケース01 -->
      <div class="te-plan-case relative mb-10 bg-co-gray-50 px-4 pb-4 pt-5 md:mb-20 md:px-14 md:pb-14 md:pt-12">
        <div class="te-plan-case-badge absolute flex flex-col items-center justify-center text-center font-bold leading-none text-co-gray-50 ">
          case
          <span class="te-case-num">01</span>
        </div>
        <div class="mb-8 flex flex-col items-center justify-center gap-5 bg-co-gray-100 px-5 py-4 md:flex-row md:justify-start">
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Plan/icon-female.svg"
            width="100"
            height="100"
            loading="lazy"
          >
          <div>
            <div class="co-displa-11 mb-3 font-bold">
              受講生の要望
              <span class="co-display-13 ml-4 font-normal text-co-gray-600">40代女性 事務職</span>
            </div>
            <ul class="list-disc pl-4 text-co-gray-600">
              <li>
                <span class="font-bold">子どもの受験と仕事もあるが合間</span>で学習したい
              </li>
              <li>
                <span class="font-bold">副業フリーランスとして通用する実力を身につけ、副業</span>をスタートさせたい
              </li>
            </ul>
          </div>
        </div>
        <h3 class="co-display-8 relative mb-8 text-center font-bold leading-none">
          <span class="relative z-10">ご提案のプラン</span>
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Plan/plan-triangle.svg"
            width="240"
            height="32"
            loading="lazy"
            class="te-plan-triangle absolute"
          >
        </h3>
        <div class="mb-8 text-co-gray-600">
          前半は、お子様の受験期間とタイミングが重なるため学習時間を<span class="font-bold">短めに、</span><br>後半は、じっくりと時間をかけ、副業フリーランスとしてのスキル習得が可能なプランをご提案。
        </div>
        <h3 class="co-display-11 mb-4 text-center font-bold">
          <span class="te-plan-text-color co-display-12 block font-bold">学習期間 7ヶ月</span>
          ライフスタイルに優しい学習ペース
        </h3>
        <div class="mb-8 flex flex-col items-center justify-center gap-10 md:flex-row">
          <div>
            <img
              src="~/assets/images/Te/TeCourse/Ordermade/Plan/case1-first-half.svg"
              width="374"
              height="219"
              class="mb-2"
              loading="lazy"
              alt="前半はお子様の受験のため学習時間を抑える"
            >
            <h4 class="co-display-12 text-center font-bold">
              Webサイト制作の基礎
            </h4>
          </div>
          <div>
            <img
              src="~/assets/images/Te/TeCourse/Ordermade/Plan/case1-second-half.svg"
              width="374"
              height="219"
              class="mb-2"
              loading="lazy"
              alt="後半は受験が終わったので学習に専念"
            >
            <h4 class="co-display-12 text-center font-bold">
              Webサイト制作の発展＋webデザイン
            </h4>
          </div>
        </div>
        <h3 class="co-display-11 mb-4 text-center font-bold">
          学習で身につける実践的なスキル
        </h3>
        <div class="mb-3 text-co-gray-600">
          フロントエンドに加えてデザインを合わせた内容でご提案し、広く活躍できるスキル習得を実現。
        </div>
        <div class="mb-8 flex flex-col items-center justify-around gap-12 md:flex-row">
          <div>
            <h5 class="co-display-12 mb-2 text-center font-bold">
              フロントエンド
            </h5>
            <div class="flex flex-row items-center justify-center gap-5">
              <div class="co-display-14 text-center text-co-gray-600">
                <img
                  src="~/assets/images/Te/TeCourse/Ordermade/Plan/icon-html.svg"
                  alt="HTML"
                  width="32"
                  height="32"
                  loading="lazy"
                  class="mx-auto"
                >
                HTML
              </div>
              <div class="co-display-14 text-center text-co-gray-600">
                <img
                  src="~/assets/images/Te/TeCourse/Ordermade/Plan/icon-css.svg"
                  alt="CSS"
                  width="32"
                  height="32"
                  loading="lazy"
                  class="mx-auto"
                >
                CSS
              </div>
              <div class="co-display-14 text-center text-co-gray-600">
                <img
                  src="~/assets/images/Te/TeCourse/Ordermade/Plan/icon-javascript.svg"
                  alt="Javascript"
                  width="32"
                  height="32"
                  loading="lazy"
                  class="mx-auto"
                >
                Javascript
              </div>
              <div class="co-display-14 text-center text-co-gray-600">
                <img
                  src="~/assets/images/Te/TeCourse/Ordermade/Plan/icon-vue.svg"
                  alt="Vue.js"
                  width="32"
                  height="32"
                  loading="lazy"
                  class="mx-auto"
                >
                Vue.js
              </div>
            </div>
          </div>
          <div>
            <h5 class="co-display-12 mb-2 text-center font-bold">
              Webデザイン
            </h5>
            <div class="flex flex-row items-center justify-center gap-5">
              <div class="co-display-14 text-center text-co-gray-600">
                <img
                  src="~/assets/images/Te/TeCourse/Ordermade/Plan/icon-photoshop.svg"
                  alt="Photoshop"
                  width="32"
                  height="32"
                  loading="lazy"
                  class="mx-auto"
                >
                Photoshop
              </div>
              <div class="co-display-14 text-center text-co-gray-600">
                <img
                  src="~/assets/images/Te/TeCourse/Ordermade/Plan/icon-design-rule.svg"
                  alt="デザインの原則"
                  width="32"
                  height="32"
                  loading="lazy"
                  class="mx-auto"
                >
                デザインの原則
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col items-center justify-center gap-12 md:flex-row">
          <div class="w-full">
            <h4 class="co-display-13 mb-2 inline-block font-bold">
              カウンセラーの声
              <img
                src="~/assets/images/Te/TeCourse/Ordermade/Plan/counselor-underline.svg"
                width="112"
                height="6"
                class="mt-1"
                loading="lazy"
              >
            </h4>
            <div class="co-display-13 text-co-gray-600">
              お子様が受験を控えているお忙しい状況とお聞きし、無理なく学習いただくを一番に考慮させていただきました。またデザインを学ぶ件は副業フリーランスとしての強みになるためご提案させていただきました。
            </div>
          </div>
          <div class="w-full">
            <h4 class="co-display-13 mb-2 font-bold">
              受講生の声
              <img
                src="~/assets/images/Te/TeCourse/Ordermade/Plan/user-underline.svg"
                width="70"
                height="6"
                class="mt-1"
                loading="lazy"
              >
            </h4>
            <div class="co-display-13 text-co-gray-600">
              「こんなふうになれたらな」と漠然と感じていたことが、学習内容やスケジュールを具体的に示していただいたことで、「これならできそう…！」という期待に変わりました！
            </div>
          </div>
        </div>
      </div>
      <!-- ケース02 -->
      <div class="te-plan-case relative  bg-co-gray-50 px-4 pb-4 pt-5 md:px-14 md:pb-14 md:pt-12">
        <div class="te-plan-case-badge absolute flex flex-col items-center justify-center text-center font-bold leading-none text-co-gray-50 ">
          case
          <span class="te-case-num">02</span>
        </div>
        <div class="mb-8 flex flex-col items-center justify-center gap-5 bg-co-gray-100 px-5 py-4 md:flex-row md:justify-start">
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Plan/icon-men.svg"
            width="100"
            height="100"
            loading="lazy"
          >
          <div>
            <div class="co-displa-11 mb-3 font-bold">
              受講生の要望
              <span class="co-display-13 ml-4 font-normal text-co-gray-600">30代男性 営業職</span>
            </div>
            <ul class="list-disc pl-4 text-co-gray-600">
              <li>
                スキルを身につけて自身の<span class="font-bold">市場価値</span>を上げたい
              </li>
              <li>
                <span class="font-bold">料金は安く</span>抑えて学習をはじめたい
              </li>
            </ul>
          </div>
        </div>
        <h3 class="co-display-8 relative mb-8 text-center font-bold leading-none">
          <span class="relative z-10">ご提案のプラン</span>
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Plan/plan-triangle.svg"
            width="240"
            height="32"
            loading="lazy"
            class="te-plan-triangle absolute"
          >
        </h3>
        <div class="mb-8 text-co-gray-600">
          ご自身の過去の経験を活かしながら、<span class="font-bold">市場価値を上げられるスキル</span>を選択し、<br>前半は経験のある分野を短い期間で復習し、後半は新しいスキルを<span class="font-bold">集中して学べるプラン</span>をご提案。
        </div>
        <h3 class="co-display-11 mb-4 text-center font-bold">
          <span class="te-plan-text-color co-display-12 block font-bold">学習期間 7ヶ月</span>
          新しいスキルをしっかり学ぶ学習ペース
        </h3>
        <div class="mb-8 flex flex-col items-center justify-center gap-10 md:flex-row">
          <div>
            <img
              src="~/assets/images/Te/TeCourse/Ordermade/Plan/case2-first-half.svg"
              width="374"
              height="219"
              loading="lazy"
              class="mb-2"
              alt="Pythonの経験があり短めの受講期間 "
            >
            <h4 class="co-display-12 text-center font-bold">
              Python
            </h4>
          </div>
          <div>
            <img
              src="~/assets/images/Te/TeCourse/Ordermade/Plan/case2-second-half.svg"
              width="374"
              height="219"
              loading="lazy"
              class="mb-2"
              alt="経験のないスキルを集中して学ぶ"
            >
            <h4 class="co-display-12 text-center font-bold">
              データサイエンス・AI
            </h4>
          </div>
        </div>
        <h3 class="co-display-11 mb-4 text-center font-bold">
          学習で身につける実践的なスキル
        </h3>
        <div class="mb-3 text-co-gray-600">
          AIやデータサイエンスに必要なPythonを復習し、市場価値の高いAIスキル習得を実現。
        </div>
        <div class="mb-8 flex items-center justify-center">
          <div>
            <div class="flex flex-row items-center justify-center gap-5">
              <div class="co-display-14 text-center text-co-gray-600">
                <img
                  src="~/assets/images/Te/TeCourse/Ordermade/Plan/icon-python.svg"
                  alt="Python"
                  width="32"
                  height="32"
                  loading="lazy"
                  class="mx-auto"
                >
                Python
              </div>
              <div class="co-display-14 text-center text-co-gray-600">
                <img
                  src="~/assets/images/Te/TeCourse/Ordermade/Plan/icon-datascience.svg"
                  alt="データサイエンス"
                  width="32"
                  height="32"
                  loading="lazy"
                  class="mx-auto"
                >
                データサイエンス
              </div>
              <div class="co-display-14 text-center text-co-gray-600">
                <img
                  src="~/assets/images/Te/TeCourse/Ordermade/Plan/icon-ai.svg"
                  alt="AI"
                  width="32"
                  height="32"
                  loading="lazy"
                  class="mx-auto"
                >
                AI
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col items-center justify-center gap-12 md:flex-row">
          <div class="w-full">
            <h4 class="co-display-13 mb-2 inline-block font-bold">
              カウンセラーの声
              <img
                src="~/assets/images/Te/TeCourse/Ordermade/Plan/counselor-underline.svg"
                width="112"
                height="6"
                class="mt-1"
                loading="lazy"
              >
            </h4>
            <div class="co-display-13 text-co-gray-600">
              将来の展望に悩まれてご相談にいらっしゃいました。興味のある分野が多々ある中から、過去のご経験とのマッチ度合いや今後の市場価値の高さを考慮してスキルをご提案しました。
            </div>
          </div>
          <div class="w-full">
            <h4 class="co-display-13 mb-2 font-bold">
              受講生の声
              <img
                src="~/assets/images/Te/TeCourse/Ordermade/Plan/user-underline.svg"
                width="70"
                height="6"
                class="mt-1"
                loading="lazy"
              >
            </h4>
            <div class="co-display-13 text-co-gray-600">
              学習目的や抱えている課題をしっかりと理解した上で、私のやりたいことや希望がいくつもある中で、市場価値の高いスキルを選んでいただいたおかげで、頭の中がスッキリ整理されました。
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style scoped>
.te-plan-case {
  border: 2px solid #7CE4C1;
  border-radius: 1.25rem;
}

.te-plan-case-badge {
  top: -0.75rem;
  left: -0.75rem;
  width: 5rem;
  height: 5rem;
  vertical-align: middle;
  background: #7CE4C1;
  @media (min-width: 1200px) {
    top: -2.25rem;
    left: -2.25rem;
  }
}

.te-case-num {
  font-size: 2.25rem;
}

.te-plan-triangle {
  left: 50%;
  margin-top: -0.875rem;
  margin-left: -7.5rem;
}

.te-plan-text-color {
  color: #03C584;
}
</style>
